import React from 'react';
import { Trash2, History } from 'lucide-react';

const SerialNoView = () => {
   return (
      <>
         <div className="p-4 bg-slate-900/30 rounded-lg border border-slate-700/50">
            <div
               className="overflow-x-auto overflow-y-auto max-h-[342px]"
               style={{
                  scrollbarWidth: 'thin',
                  scrollbarColor: 'rgba(71, 85, 105, 0.5) transparent',
               }}>
               <table className="w-full">
                  <thead className="sticky top-0">
                     <tr className="border-b border-slate-700/50 bg-slate-900/80 backdrop-blur-sm">
                        <th className="text-center px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                           No.
                        </th>
                        <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider min-w-96">
                           Item
                        </th>
                        <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider min-w-96">
                           Serial No.
                        </th>
                        <th className="text-center px-4 py-3 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                           Action
                        </th>
                     </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-700/30">
                     {new Array(15).fill('').map((item, index) => (
                        <tr key={index} className="group hover:bg-slate-800/40 transition-colors duration-150">
                           <td className="px-4 py-3 text-center">
                              <span className="text-sm text-slate-300">{index + 1}</span>
                           </td>
                           <td className="px-4 py-3">
                              <span className="text-sm text-slate-200">Apple Mac Mini</span>
                           </td>
                           <td className="px-4 py-3">
                              <span className="text-sm text-cyan-400 flex gap-3 justify-start items-center">
                                 SEKCIIDJIFICC{' '}
                                 <History className="w-4 h-4 text-slate-400 hover:text-slate-300 cursor-pointer" />
                              </span>
                           </td>
                           <td className="px-4 py-3 text-center">
                              {new Array(10).length > 1 && (
                                 <button
                                    // onClick={() => removeItem(item.id)}
                                    className="opacity-0 group-hover:opacity-100 p-2 hover:bg-red-500/20 rounded-lg transition-all duration-200 inline-flex items-center justify-center"
                                    title="Delete item">
                                    <Trash2 className="w-4 h-4 text-red-400 hover:text-red-300" />
                                 </button>
                              )}
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
};

export default SerialNoView;
